import { useCallback, useState } from 'react';

import type { Dispatch, SetStateAction } from 'react';

/**
 * Hook for managing boolean toggle state (dialogs, edit modes, etc.).
 *
 * @param {boolean} defaultValue - Initial state (default: false)
 * @returns {Array} [value, toggle, setValue]
 */
export const useToggle = (defaultValue?: boolean): [boolean, () => void, Dispatch<SetStateAction<boolean>>] => {
    const [value, setValue] = useState(!!defaultValue);

    const toggle = useCallback(() => {
        setValue(x => !x);
    }, []);

    return [value, toggle, setValue];
};
